export function getView(lead) {
  if (lead.status === 'dismissed') return 'No'
  return lead.patient_id ? 'GoToPatientProfile' : 'CreatePatient'
}
